import { createContext, useContext } from 'react';

export interface IGlobalPropertyContext {
  getProperties: () => void;
  shortDateFormat: string;
  midDateFormat: string;
  longDateFormat: string;
  currency: string;
  unit: string;
}

export const GlobalPropertyContext = createContext<IGlobalPropertyContext>(
  {} as IGlobalPropertyContext,
);

export const useGlobalProperty = (): IGlobalPropertyContext =>
  useContext(GlobalPropertyContext);
